import React from 'react';
import PropTypes from 'prop-types';
import {
  FDAccordion,
  FDAccordionDetails,
  FDAccordionGroup,
  FDAccordionTitle,
  FDBox,
  FDEmptyState,
  FDSecondaryActionIconButton,
  FDStack,
  FDTitleText,
  FDIcon,
} from '@facet-wealth/design';
import { noop } from 'Helpers/PropTypes';
import fr from 'facet-rest';
import { dataAttrs, testAttr } from 'Helpers/Testing';
import { AccordionCategoryListContent } from './AccordionCategoryListContent';

const categoryTypeIconMap = {
  infrequentExpense: 'dateRange',
  expense: null,
  job: null,
};

export const AccordionCategoryList = ({
  categoriesCollection,
  onEditCategoryClick,
  onEditLineItemClick,
  ListItemComponent,
  emptyTitle,
  emptyDescription,
}) => {
  return (
    <>
      {categoriesCollection.resources().length() === 0 ? (
        <FDEmptyState
          icon={'search'}
          title={emptyTitle}
          description={emptyDescription}
        />
      ) : (
        <FDAccordionGroup>
          {categoriesCollection.resources().list().map((categoryResource) => {
            return (
              <FDAccordion
                key={categoryResource.id()}
                expansionID={categoryResource.id()}
                {...dataAttrs('category-accordion', categoryResource)}
              >
                <FDAccordionTitle {...dataAttrs('category-accordion-title', categoryResource)}>
                  <FDStack alignItems={'center'} justifyContent={'space-between'} flex={1}>

                    <FDStack alignItems={'center'} flex={1} spacing={1}>
                      {categoryTypeIconMap[categoryResource.attr('categoryType')] && (
                        <FDIcon icon={categoryTypeIconMap[categoryResource.attr('categoryType')]} size={'sm'} />
                      )}
                      <FDTitleText
                        {...dataAttrs('category-accordion-title-text', {
                          [testAttr.dataValue]: categoryResource.attr('categoryName'),
                        })}
                        value={categoryResource.attr('categoryName')}
                      />

                      {categoryResource.withRelationship(
                        fr.relationships.edit.name,
                        (rel) => (
                          <FDSecondaryActionIconButton
                            icon="edit"
                            onClick={onEditCategoryClick(rel)}
                            data-test="edit-category-button"
                          />
                        ),
                        () => null,
                      )}
                    </FDStack>

                    <FDBox paddingX={1}>
                      {!categoryResource.meta().field('total').attr('hidden') && <FDTitleText value={categoryResource.attr('total')} />}
                    </FDBox>
                  </FDStack>
                </FDAccordionTitle>
                <FDAccordionDetails>
                  <AccordionCategoryListContent
                    lineItems={categoryResource.attr('lineItems')?.resources()?.list() || []}
                    onEditLineItemClick={onEditLineItemClick}
                    ItemComponent={ListItemComponent}
                  />
                </FDAccordionDetails>
              </FDAccordion>
            );
          })}
        </FDAccordionGroup>
      )}
    </>
  );
};

AccordionCategoryList.defaultProps = {
  onEditCategoryClick: noop,
};

AccordionCategoryList.propTypes = {
  categoriesCollection: PropTypes.object.isRequired,
  onEditCategoryClick: PropTypes.func,
  onEditLineItemClick: PropTypes.func.isRequired,
  ListItemComponent: PropTypes.func.isRequired,
  emptyTitle: PropTypes.string.isRequired,
  emptyDescription: PropTypes.string.isRequired,
};
